import { useAppSelector } from "./redux";
import { hasExternalProviderNavigator } from "../util/navigatorCustomTodoAccess";

/**
 * Whether the selected clinic has the `navigator-external-providers` clinic
 * beta feature. Re-renders when the clinic beta list loads or changes.
 */
export const useExternalProviderNavigator = (): boolean =>
  useAppSelector((state) =>
    hasExternalProviderNavigator(state.auth.clinicBetaFeaturesAllowedList)
  );
